"use strict";

var _ = require('lodash');

var React = require('react');

var PropTypes = require('prop-types');

var createCompositeChildrenValidation = require('../util/createCompositeChildrenValidation');

var getExtraStyleProps = function getExtraStyleProps(props, extraStyleProps) {
  return extraStyleProps ? {
    style: _.pick(props, extraStyleProps)
  } : {};
};

module.exports = function (compositeDef) {
  var Composite = function Composite(props) {
    return React.createElement('div', _.assign({
      className: [compositeDef.className, props.className].join(' '),
      'data-aid': props.automationId
    }, getExtraStyleProps(props, _.keys(compositeDef.extraStyleProps))), props.children);
  };

  var compositeChildrenValidation = createCompositeChildrenValidation(compositeDef);
  Composite.displayName = compositeDef.displayName;

  Composite.getDisplayName = function () {
    return compositeDef.displayName;
  };

  Composite.propTypes = _.assign({
    className: PropTypes.string,
    automationId: PropTypes.string,
    children: function children(props, propName, componentName) {
      return compositeChildrenValidation(props, propName, componentName);
    }
  }, compositeDef.extraStyleProps);
  return Composite;
};